import React, { useState, useRef, useEffect } from "react";
import { Button, OverlayTrigger, Tooltip, Badge } from 'react-bootstrap';
import { BsSave, BsFillCaretDownFill, BsCloudUpload, BsCloudDownload, BsUpload, BsFillFileEarmarkArrowDownFill, BsDownload, BsBarChart, BsMap  } from 'react-icons/bs';
import "./style.css";
import DatePicker from "react-multi-date-picker"
import transition from "react-element-popper/animations/transition"
import opacity from "react-element-popper/animations/opacity"

//action
const TODIS_PRIMARY_BTN = (props) => {
    return (
        <Button variant="primary" style={styles} onClick={props.onclick} href="/">{props.title} <img src={props.image} width="15" className="todis-icon-btn" alt={props.title} /></Button>
    )
}

/* const TODIS_PRIMARY_SUBMIT_BTN = (props) => {
    return (
        <Button variant="primary" type="submit" value={props.value} style={styles} onClick={props.onclick} >{props.title} <img src={props.image} width="15" className="todis-icon-btn" alt={props.title} /></Button>
    )
} */

const TODIS_PRIMARY_SUBMIT_BTN = (props) => {
    return (
        <Button
            variant="primary"
            type={props.type}
            value={props.value}
            style={styles}
            onClick={props.onclick}
        >
            {props.title} {props.icon}
        </Button>
    );
};

//secondary
/* const TODIS_SECONDARY_BTN = (props) => {
    return (
        <Button variant="primary" style={sec_styles} onClick={props.onclick} className={props.className}><img src={props.image} width="15" className="todis-icon-left-btn" alt={props.title} /> {props.title} </Button>
    )
} */

const TODIS_SECONDARY_BTN = (props) => {
    const handleClick = () => {
        if (props.onclick) {
            props.onclick();
        }
    };

    const renderIcon = () => {
        switch (props.iconName) {
            case 'save':
                return <BsSave size={15} className="todis-icon-left-btn" />;
            case 'caretDown':
                return <BsFillCaretDownFill size={15} className="todis-icon-left-btn" />;
            case 'download':
                return <BsCloudDownload size={15} className="todis-icon-left-btn" />;
            case 'downloadExcel':
                return <BsDownload size={15} className="todis-icon-left-btn" />;
            case 'chart':
                return <BsBarChart size={15} className="todis-icon-left-btn" />;
            case 'map':
                return <BsMap size={15} className="todis-icon-left-btn" />;
            case 'upload':
                return <BsCloudUpload size={15} className="todis-icon-left-btn" />;
            case 'template':
                return <BsFillFileEarmarkArrowDownFill size={15} className="todis-icon-left-btn" />;
            default:
                return null;
        }
    };
    
    return (
        <Button
            variant="primary"
            style={sec_styles}
            onClick={handleClick}
            className={props.className}
        >
            {renderIcon()}
            {props.title}
        </Button>
    );
};

const TODIS_SECONDARY_BTN_IMPORT = (props) => {
    const tooltip = <Tooltip id="tooltip">{props.tooltipText}</Tooltip>;

    return (
        <OverlayTrigger
            placement="top"
            overlay={tooltip}
        >
            <Button variant="primary" style={sec_styles} onClick={props.onclick} className={props.className}><img src={props.image} width="15" className="todis-icon-left-btn" alt={props.title} /> {props.title} </Button>
        </OverlayTrigger >
    )
}


//tertiary
const TODIS_TERTIARY_BTN = (props) => {
    return (
        <Button variant="primary" className="ter_styles" onClick={props.onclick}><img src={props.image} width="15" className="todis-icon-left-btn" alt={props.title} /> {props.title} </Button>
    )
}


//outlined
const TODIS_OUTLINE_BTN = (props) => {
    return (
        <Button variant="outline" style={outline_styles} onClick={props.onclick}><img src={props.image} width="15" className="todis-icon-left-btn" alt={props.title} /> {props.title} </Button>
    )
}

//outlined
const TODIS_OUTLINE_BTN_R = (props) => {
    return (
        <Button variant="outline" style={outline_styles} onClick={props.onclick}>{props.title} <img src={props.image} width="15" className="todis-icon-btn" alt={props.title} /> </Button>
    )
}


//sucess button 
const TODIS_SUCCESS_BTN = (props) => {
    return (
        <Button variant="success" style={success_styles} onClick={props.onclick}><img src={props.image} width="15" className="todis-icon-left-btn" alt={props.title} /> {props.title} </Button>
    )
}

//danger button (outlined)
const TODIS_DANGER_BTN = (props) => {
    return (
        <Button variant="danger" className={props.classes} style={danger_styles} onClick={props.onclick}><img src={props.image} width="15" className="todis-icon-left-btn" alt={props.title} /> {props.title} </Button>
    )
}


/* const TODIS_BTN_PRIMARY = (props) => {
    return (
        <Button variant="primary" className="ter_styles" style={props.style} disabled={props.disabled} onClick={props.onclick}><props.icon size={props.sizeIcon ? props.sizeIcon : "18"}/> {props.title}</Button>
    )
} */

const TODIS_BTN_PRIMARY = (props) => {
    const tooltip = <Tooltip id="tooltip">{props.tooltipText}</Tooltip>;

    return (
        <OverlayTrigger
            placement="top"
            overlay={tooltip}
        >
            <Button
                variant="primary"
                className="ter_styles"
                style={props.style}
                disabled={props.disabled}
                onClick={props.onclick}
            >
                <props.icon size={props.sizeIcon ? props.sizeIcon : "18"} /> {props.title}
            </Button>
        </OverlayTrigger>
    );
};

const TODIS_BTN_SECUNDARY = (props) => {

    return (
        <Button variant="primary" className={props.classes} style={props.type == "sharing" ? { ...sec_styles2, ...props.style } : { ...sec_styles, ...props.style }} disabled={props.disabled} onClick={props.onclick}>{props.icon != undefined ? <props.icon size={props.sizeIcon ? props.sizeIcon : "18"} /> : null} {props.title}</Button>
    )
}

const TODIS_BTN_SECUNDARY_LIGHT = (props) => {
    return (
        <Button variant="light" className={props.classes} style={sec_styles2} disabled={props.disabled} onClick={props.onclick}>{props.icon != undefined ? <props.icon size={props.sizeIcon ? props.sizeIcon : "18"} /> : null} {props.title}</Button>
    )
}

const TODIS_BTN_DANGER = (props) => {
    return (
        <Button variant="danger" className={props.classes} style={danger_styles} onClick={props.onclick}>{props.icon != undefined ? <props.icon style={icon_danger_styles} size={props.sizeIcon ? props.sizeIcon : "18"} /> : null} {props.title}</Button>
    )
}

const TODIS_BTN_BADGE = (props) => {
    return (
        <Button variant="light" onClick={props.onclick} className={props.classes}><Badge bg="secondary">x</Badge> {props.label} <span className="visually-hidden">{props.label}</span></Button>
    )
}

const TODIS_PRIMARY_SMALL_BTN = (props) => {
    return (
        <Button variant="primary" style={small_styles} onClick={props.onclick} href="/">{props.title} </Button>
    )
}

const TODIS_DATEPICKER = (props) => {

    const datePickerRef = useRef()
    const [value, setValue] = useState({})

    const getValue = () => {
        // console.log(datePickerRef.current.firstChild.value)
        props.handleDate(datePickerRef.current.firstChild.value);
        datePickerRef.current.closeCalendar();
        if (props.text == "Filter") {
            setValue({})
        }
    }

    const onChange = (value) => {
        //console.log(value)
    }

    return (
        <DatePicker
            ref={datePickerRef}
            value={value}
            onlyYearPicker={props.onlyYearPicker}
            onChange={onChange}
            animations={[
                opacity(),
                transition({ from: 35, duration: 800 })
            ]}
            containerStyle={props.containerStyle}
            style={{
                backgroundColor: "#E3F2FD",
                borderColor: "#E3F2FD",
                fontSize: "12px",
                color: "#004494",
                padding: "0.7rem 1rem",
                borderRadius: "12px",
                letterSpacing: '1px',
                textAlign: "left",
                height: "auto",
                width: props.text == "Filter" ? "70px" : "100%"
            }}
            placeholder={props.placeholder}
            range
        ><Button
            style={{ margin: "5px" }}
            onClick={() => getValue()}
        >
                {props.text}
            </Button>
        </DatePicker>
    )
};

const TODIS_YEAR_PICKER = (props) => {
    const datePickerRef = useRef();
    const [value, setValue] = useState(null); // Inicializa sin valor seleccionado

    const onChange = (selectedValue) => {
        // Verifica que el objeto seleccionado tenga la propiedad `year`
        if (selectedValue && selectedValue.year) {
            const year = selectedValue.year; // Extrae el año del objeto
            setValue(year); // Guarda el año seleccionado
            props.handleDate(year); // Llama a handleDate automáticamente al seleccionar el año
        } else {
            console.error("Invalid value type for year:", selectedValue); // Log para errores
        }
    };

    return (
        <DatePicker
            ref={datePickerRef}
            value={value} // No se selecciona por defecto
            onlyYearPicker // Asegúrate de que solo se pueda seleccionar el año
            onChange={onChange} // Llama a onChange al seleccionar un año
            placeholder="Year" // Placeholder para seleccionar el año
            containerStyle={props.containerStyle}
            style={{
                backgroundColor: "#E3F2FD",
                borderColor: "#E3F2FD",
                fontSize: "12px",
                color: "#004494",
                padding: "0.7rem 1rem",
                borderRadius: "12px",
                letterSpacing: '1px',
                textAlign: "left",
                height: "auto",
                width: "100%", // Ajusta según sea necesario
            }}
        />
    );
};

const TODIS_DATEPICKER_INDV = (props) => {
    const datePickerRef = useRef();
    // Inicializar el estado con una fecha usando el año proporcionado
    const [selectedDate, setSelectedDate] = useState(() => {
        return props.value ? new Date(parseInt(props.value), 0, 1) : null;
    });

    // Actualizar el estado cuando cambie el valor en las props
    useEffect(() => {
        if (props.value) {
            setSelectedDate(new Date(parseInt(props.value), 0, 1));
        } else {
            setSelectedDate(null);
        }
    }, [props.value]);

    const onChange = (selectedValue) => {
        let year;
        
        if (selectedValue?.year) {
            year = selectedValue.year;
        } else if (selectedValue instanceof Date) {
            year = selectedValue.getFullYear();
        } else if (selectedValue) {
            year = parseInt(selectedValue, 10);
        }

        if (year && !isNaN(year)) {
            const newDate = new Date(year, 0, 1);
            setSelectedDate(newDate);
            props.handleDate(year, props.name);
        } else {
            setSelectedDate(null);
            props.handleDate(null, props.name);
        }
    };

    return (
        <DatePicker
            ref={datePickerRef}
            value={selectedDate}
            onlyYearPicker={true}
            onChange={onChange}
            animations={[
                opacity(),
                transition({ from: 35, duration: 800 })
            ]}
            containerStyle={props.containerStyle}
            style={{
                backgroundColor: "#E3F2FD",
                borderColor: "#E3F2FD",
                fontSize: "12px",
                color: "#004494",
                padding: "0.7rem 1rem",
                borderRadius: "12px",
                letterSpacing: "1px",
                textAlign: "left",
                height: "auto",
                width: "100%"
            }}
            placeholder="Select Year"
            minDate={new Date(2015, 0, 1)}
            maxDate={new Date(2030,0, 1)}
            range={false}
            format="YYYY"
        />
    );
};

export { TODIS_DATEPICKER_INDV, TODIS_SECONDARY_BTN_IMPORT, TODIS_BTN_SECUNDARY_LIGHT, TODIS_BTN_BADGE, TODIS_BTN_DANGER, TODIS_PRIMARY_BTN, TODIS_PRIMARY_SUBMIT_BTN, TODIS_SECONDARY_BTN, TODIS_TERTIARY_BTN, TODIS_OUTLINE_BTN, TODIS_BTN_PRIMARY, TODIS_BTN_SECUNDARY, TODIS_DANGER_BTN, TODIS_SUCCESS_BTN, TODIS_OUTLINE_BTN_R, TODIS_DATEPICKER, TODIS_PRIMARY_SMALL_BTN, TODIS_YEAR_PICKER };


//=========================================================================================================================================================

const styles = {
    backgroundColor: "#FFC61C",
    fontSize: "0.85rem",
    fontWeight: "bold",
    borderColor: "#FFC61C",
    textTransform: "uppercase",
    padding: "1rem 1.5rem",
    borderRadius: "18px",
    letterSpacing: '1px',
    width: "100%",
    textAlign: "left"
}

const sec_styles = {
    backgroundColor: "#E3F2FD",
    borderColor: "#E3F2FD",
    fontSize: "14px",
    color: "#004494",
    padding: "0.7rem 1.4rem",
    borderRadius: "12px",
    letterSpacing: '1px',
    textAlign: "left"
}
const sec_styles2 = {
    //borderColor: "#E3F2FD",
    fontSize: "14px",
    color: "#004494",
    //padding: "0.7rem 1.4rem",
    borderRadius: "12px",
    letterSpacing: '1px',
    textAlign: "left"
}

const outline_styles = {
    backgroundColor: "transparent",
    fontSize: "0.85rem",
    color: "#004494",
    fontWeight: "bold",
    border: '1.5px solid #004494',
    borderColor: "#004494",
    padding: "1rem 1.5rem",
    borderRadius: "18px",
    textTransform: "uppercase",
    letterSpacing: '1px',
    width: '100%',
    textAlign: "left"
}

const success_styles = {
    backgroundColor: "#02BC77",
    fontSize: "14px",
    color: "#fff",
    borderColor: "#02BC77",
    padding: "0.5rem 1rem",
    borderRadius: "12px"
}

const danger_styles = {
    backgroundColor: "transparent",
    fontSize: "14px",
    color: "#000000",
    border: "none"
}

const icon_danger_styles = {
    color: "#FF0000",
}

const small_styles = {
    backgroundColor: "#FFC61C",
    fontWeight: "bold",
    borderColor: "#FFC61C",
    textTransform: "uppercase",
    padding: "1rem 1.5rem",
    borderRadius: "18px",
    letterSpacing: '1px',
    width: '100%',
    textAlign: "left",
    fontSize: "10px"
}